import { TableBody, TableCell, TableHead, TableRow } from '@mui/material'
import type { MultipleChoiceSet } from '@ulysses-inc/harami_api_client'
import type { FC } from 'react'
import { useDispatch } from 'react-redux'
import multipleChoiceSetsOperations from 'src/state/ducks/multipleChoiceSets/operations'
import MultipleChoiceSetListRow from './MultipleChoiceSetListRow'

interface OwnProps {
  multipleChoiceSets: MultipleChoiceSet[]
}

const MultipleChoiceSetList: FC<OwnProps> = ({ multipleChoiceSets }) => {
  const dispatch = useDispatch()
  const deleteMultipleChoiceSet = (multipleChoiceSetId: string) => {
    multipleChoiceSetsOperations.deleteMultipleChoiceSet(
      dispatch,
      multipleChoiceSetId,
    )
  }

  return (
    <>
      <TableHead>
        <TableRow>
          <TableCell size="small" sx={{ fontWeight: 'bold' }}>
            セット選択名
          </TableCell>
          <TableCell size="small" aria-label="操作" />
        </TableRow>
      </TableHead>
      <TableBody>
        {multipleChoiceSets.map(multipleChoiceSet => (
          <MultipleChoiceSetListRow
            key={multipleChoiceSet.uuid}
            multipleChoiceSet={multipleChoiceSet}
            deleteMultipleChoiceSet={deleteMultipleChoiceSet}
          />
        ))}
      </TableBody>
    </>
  )
}

export default MultipleChoiceSetList
